import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import {_delete, get, patch} from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import {BeatLoader} from 'react-spinners';
import ReactTable from 'react-table';
import {Link} from 'react-router-dom';
import active from "../../../assets/img/active.png";
import warn from "../../../assets/img/warning.png";
import deleted from "../../../assets/img/invalid.png";
import moment from 'moment';
import { convertTwoDecimalPoint, groupBy } from '../../../server/util';

class Subscription extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            search:'',
            mainData:[],
            filterList:[],
            expanded:{}
        }
    }
    componentWillMount=()=>{
        this.getAllList();
    }
    componentDidMount=()=> {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getAllList=()=>{
        this.setState({loading:true})
        get('/mealSchool/subscriptions?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({loading:false});
            this.filterData(data.resp);
        })
        .catch(
            (error) => {
                this.setState({loading:false})
                console.log('Get SchoolList response', error)
            }
        )
    }
    filterData=(data=[])=>{
        const {search}=this.state;
        const groupData=groupBy(data,'schoolName');
        const groupList=Object.keys(groupData).map(key=>{
            const subscriptionRec=(((groupData[key]||[])[0])||{});
            return {
                schoolName:key,
                schoolId:subscriptionRec.mealSchoolId,
                onboardedDate:subscriptionRec.onboardedDate,
                subRows:groupData[key]||[]}
        })
        if((search||'').length<=0){
            this.setState({filterList:groupList});
        }else{
            const _filterData=groupList.filter(rec=>{
                return (search||'').toLowerCase().includes((rec.schoolName||'').toLowerCase())
            });
            this.setState({filterList:_filterData||[]});
        }
    }
    getColumns=()=>{
        const columns = [            
            {
                Header: 'School',
                Cell:({row})=>{
                    return <span>{row._original.schoolName}</span>
                }
            }, 
            {
                Header: 'Onboarded On',
                Cell:({row})=>{
                    const item=row._original;
                    return <span>{moment(item.onboardedDate,'YYYY-MM-DD').isValid()?item.onboardedDate:null }</span>
                    
                },
                width: 150
            },       
            {
                Header:'ACTION',
                width: 100,
                Cell:({row})=>{
                    return <Fragment>
                        <a href="javascript:void(0);" style={{cursor:'pointer'}} className="edit-btn"
                        onClick={()=>{this.onEdit(row._original, "EDIT")}}>
                        <i className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon"/></a>
                        
                        <a href="javascript:void(0);"  className="delete-btn" style={{display:'none',cursor:'pointer'}} onClick={() => this.openModal()}>
                        <i className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon"/></a>
                    </Fragment>
                }
            }
        ];
        return columns;
    }
    getSubTableColumns=()=>{
        let cols=[
              {
                Header: 'Subscription Type',
                accessor: 'subscriptionType',
                width: 150            
            },           
            {
                Header: 'Billing Start Date',
                Cell:({row})=>{
                    const item=row._original;
                    return <span>{moment(item.billingStartDate,'YYYY-MM-DD').isValid()? moment(item.billingStartDate,'YYYY-MM-DD').format('MM-DD-YYYY'):null }</span>
                },
                width: 150
            },
            {
                Header: 'Billing End Date',
                Cell:({row})=>{
                    const item=row._original;
                    return <span>{moment(item.billingEndDate,'YYYY-MM-DD').isValid()?moment(item.billingEndDate,'YYYY-MM-DD').format('MM-DD-YYYY'):null }</span>
                },
                width: 150
            },
            {
                Header:'Charges',
                Cell:({row})=>{
                    const item=row._original;
                    return <span>{ convertTwoDecimalPoint(item.subscriptionFee||0.00) }</span>
                },
                width: 150
            }
        ];
        return cols;
    }
    onEdit=(row,action)=>{
        let id=0;
        if(row){
            id=row.schoolId||0;
            this.context.router.history.push('/superAdmin/subscription/'+id);
        }
    }
    render() {
        const {filterList, search, loading, expanded}=this.state;
        const { toggleSelection, toggleAll, isSelected } = this;
        const checkboxProps = {
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold', textAlign:'right'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    style: {
                        margin: 'auto !important'
                    },
                    className: "table table-hover"
                }
            },
        };
        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>
                <section className=" full-width clearfix">
                    <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={loading}
                        />
                    </div>
                    <div className="container-full">
                        <div className="sectionTitle">
                            <h2>
                                <span>Manage Subscription</span>
                            </h2>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                <input type="text" id="search" className="search form-control" value={search}
                                    name="search" placeholder="Search.." onChange={(e)=>{
                                        this.setState({search:e.target.value},()=>{
                                            this.filterData()
                                        });
                                    }} autocomplete='off'
                                    />
                            </div>
                            <div className="col-md-6 col-sm-12 col-xs-12 button-group-section form-group">
                                <Link className="btn btn-success button-sm add-btn-sm"
                                    id="addCaterer" onClick={()=>{}}
                                    to="/superAdmin/subscription/0"><i className="fa fa-plus"/> Add Subscription</Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-md-12'>
                                <div className="clearfix"></div>
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                        <ReactTable
                                                data={filterList}
                                                columns={this.getColumns()}
                                                expanded={expanded}
                                                defaultPageSize={10}
                                                className="-striped -highlight"
                                                noDataText='No data found'
                                                sortable={true}
                                                defaultSorting={[{
                                                    id: 'session',
                                                    desc: false
                                                }]} 
                                                minRows = {1}
                                                {...checkboxProps}
                                                onExpandedChange={expandedList => {
                                                    const expanded = {}
                                                    Object.keys(expandedList).forEach(item => {
                                                        const expand = Boolean(expandedList[item] && expandedList[item].constructor === Object)
                                                        expanded[item] = expand
                                                    })
                                                    this.setState({ expanded })
                                                }}
                                                SubComponent={(row) => {
                                                    return (<Fragment>
                                                        <div className='row'>
                                                            <div className='col-md-offset-1 col-md-10'>
                                                                <ReactTable
                                                                    data={row.original.subRows||[]}
                                                                    columns={this.getSubTableColumns()}
                                                                    defaultPageSize={10}
                                                                    className="-striped -highlight"
                                                                    noDataText='No data found'
                                                                    sortable={true}
                                                                    defaultSorting={[{
                                                                        id: 'session',
                                                                        desc: false
                                                                    }]} 
                                                                    minRows = {1} />
                                                            </div>
                                                        </div>
                                                    </Fragment>)}}
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
Subscription.contextTypes = {
    router: PropTypes.object.isRequired
}

export default Subscription;



// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Subscription/index.js